import { UseQueryOptions } from '@tanstack/react-query'

import { getStoredToken, isTokenValid } from 'core/actions/helpers/tokenHelpers'
import { peachApi } from 'core/api'
import { usePeachQuery } from 'core/system/queries'
type Params = {
  companyId: string
  options?: Partial<UseQueryOptions>
}

const useGetZendeskConfig = ({ companyId, options }: Params) => {
  const token = getStoredToken()
  const tokenIsValid = isTokenValid(token)

  const fetch = () =>
    peachApi.get({
      url: `/companies/${companyId}/config?paths=zendesk`,
    })

  return usePeachQuery({
    queryKey: ['companies', companyId, 'config'],
    queryFn: fetch,
    enabled: tokenIsValid,
    ...options,
  })
}

/** @deprecated Use the auto-generated hooks under core/types or if needed create a new hook under core/types/hooks */
export default useGetZendeskConfig
